<div style="background-color: white;">
    
    <div class="pt-1" style="position:sticky;top:0;left:0;background:white;z-index:10;">
        <div class="p-0">
            <span style="font-size:18px;font-weight:bold;" class="pr-2">
                In-Building Test Path Identification Sheet 
            </span>
            <button *ngIf="!bProcessing&&pendingPlotterImageCnt==0" class="btn btn-secondary btn-sm ml-3" style="padding: 2px 4px;"
                [disabled]="bBuildingWordDoc"
                (click)="rebuildReport()">
                Rebuild
            </button>
            <button *ngIf="!errorMsg&&!bProcessing&&pendingPlotterImageCnt==0" [disabled]="bBuildingWordDoc"
                class="btn btn-secondary btn-sm mx-3" style="padding: 2px 4px;" (click)="downloadWordDoc()">
                <i *ngIf="bBuildingWordDoc; else downloadIcon" class="fa fa-spinner fa-spin"></i>
                <ng-template #downloadIcon>
                    <i class="fa fa-file-download"></i>
                </ng-template>
                &nbsp;MS Word
            </button>
            <span *ngIf="bProcessing||pendingPlotterImageCnt>0">
                <i class="fa fa-spinner fa-spin"></i> {{this.processingMsg}}
                <span *ngIf="pendingPlotterImageCnt>0" class="pl-2 small muted font-italic">please do not {{bStandalonePageUrl?'':'leave tab, '}} scroll or resize window while map images are being created</span>
            </span>
            <span *ngIf="failedDownloadCnt" class="p-sm-1 alert alert-warning">
                Photo load error(s): {{failedDownloadCnt}}
            </span>
        </div>
        <div *ngIf="errorMsg" class="alert alert-danger">
            {{errorMsg}}
        </div>
        <hr>
    </div>

    <ng-container>
    <div class="d-flex flex-wrap py-2">
        <div class="pr-3">
            <span class="report-section-header">Location {{getPathName()}} </span>
            <span class="report-field-value" style="font-style:italic;">{{(scoutPath?.floor ? 'Floor ' + scoutPath?.floor + (building?.commonName?' @ ':''): '') + (building?.commonName||'')}}
            </span>
            <table class="report-dict table-striped table-compact">
                <tbody>
                    <tr>
                        <th class="report-dict-key">Address</th><td class="report-dict-value">{{building?.civicAddress}}</td>
                    </tr>
                    <tr>
                        <th class="report-dict-key">Category</th><td class="report-dict-value">{{building?.category}}</td>
                    </tr>
                    <tr>
                        <th class="report-dict-key">Construction</th><td class="report-dict-value">{{building?.construction}}</td>
                    </tr>
                    <tr>
                        <th class="report-dict-key">Coordinates</th><td class="report-dict-value">{{building?.civicLatitude}}, {{building?.civicLongitude}}</td>
                    </tr>
                    <tr>
                        <th class="report-dict-key">Description</th><td class="report-dict-value">{{scoutPath?.description}}</td>
                    </tr>
                </tbody>
            </table>
        </div>                

        <div >
            <span class="report-section-header">Azimuths</span>
            <table class="report-dict table-striped table-compact">
                <tbody>
                    <tr>
                        <th class="report-dict-key">Start Point</th><td class="report-dict-value">{{cornerCompassDirection}} corner</td>
                    </tr>
                    <tr>
                        <th class="report-dict-key">Exterior Wall One</th><td class="report-dict-value">
                            {{cornerDirections?.length>0&&cornerDirections[0]}} - {{cornerDirections?.length>0&&AzimuthHelper.getOppositeDirection(cornerDirections[0])}} 
                            ({{scoutPath?.azimuth1Angle|number:'0.2'}}&deg; {{cornerDirections?.length>0&&cornerDirections[0]}}) <-> ({{(scoutPath?.azimuth1Angle + 180) % 360|number:'0.2-2'}}&deg; {{cornerDirections?.length>0&&AzimuthHelper.getOppositeDirection(cornerDirections[0])}})
                        </td>
                    </tr>
                    <tr>
                        <th class="report-dict-key">Exterior Wall Two</th><td class="report-dict-value">
                            {{cornerDirections?.length>0&&cornerDirections[1]}} - {{cornerDirections?.length>0&&AzimuthHelper.getOppositeDirection(cornerDirections[1])}} 
                            ({{scoutPath?.azimuth2Angle|number:'0.2'}}&deg; {{cornerDirections?.length>0&&cornerDirections[1]}}) <-> ({{(scoutPath?.azimuth2Angle + 180) % 360|number:'0.2-2'}}&deg; {{cornerDirections?.length>0&&AzimuthHelper.getOppositeDirection(cornerDirections[1])}})
                        </td>
                    </tr>
                    <tr *ngFor="let addlAzimuth of scoutPath?.addlAzimuths">
                        <th class="report-dict-key">{{addlAzimuth.title}}</th>
                        <td class="report-dict-value">
                            {{addlAzimuth.angle|number:'0.2-2'}}&deg;
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>              
    </div>

    <table>
        <tr>
            <td style="vertical-align: top; padding:15px 0;">
                <span class="report-section-header">High Accuracy Point</span>
                <table class="report-dict table-striped table-compact">
                    <tbody>
                        <tr *ngIf="scoutPathStartPt?.disabled">
                            <td colspan="2" class="text-center text-danger font-weight-bold font-italic"
                            style="background-color: rgba(255, 242, 0, 0.863);">DISABLED</td>
                        </tr>
                        <tr>
                            <th class="report-dict-key">ID</th><td class="report-dict-value">{{scoutPathStartPt?.pointId || scoutPathStartPt?.exPointId}}</td>
                        </tr>
                        <tr>
                            <th class="report-dict-key">Latitude</th><td class="report-dict-value">{{scoutPathStartPt?.latitude}}</td>
                        </tr>
                        <tr>
                            <th class="report-dict-key">Longitude</th><td class="report-dict-value">{{scoutPathStartPt?.longitude}}</td>
                        </tr>
                        <tr>
                            <th class="report-dict-key">Elevation</th><td class="report-dict-value">{{scoutPathStartPt?.altitudeEllipsoidMeters}} meter(s)</td>
                        </tr>
                        <tr>
                            <th class="report-dict-key">Horiz Error</th><td class="report-dict-value">{{scoutPathStartPt?.horizontalError.cumulativeEstimate}} meter(s)</td>
                        </tr>
                        <tr>
                            <th class="report-dict-key">Vert Error</th><td class="report-dict-value">{{scoutPathStartPt?.verticalError.segmentEstimate}} meter(s)</td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="!scoutPathStartPt?.pointId" class="small text-muted font-italic">
                    * Approximate Coordinates
                </div>
            </td>
            <td style="vertical-align: top; padding:15px;">                
                <span class="report-section-header">Path Segment A</span>
                <ng-container [ngTemplateOutlet]="pathSegmentTable"
                    [ngTemplateOutletContext]="{ scoutPoints: segmentAScoutPoints }">
                </ng-container>
                <ng-template #pathSegmentTable let-scoutPoints="scoutPoints">
                <table class="report-table table-striped table-compact">
                    <thead>
                    <tr>
                        <th rowspan="2">Point</th>
                        <th rowspan="2">From</th>
                        <th rowspan="2">Horiz<br>Dist.</th>
                        <th rowspan="2">Horiz<br>Error</th>
                        <th rowspan="2">Bearing</th>
                        <th rowspan="2">Height<br>Offset</th>
                        <th rowspan="2">Vert<br>Error</th>
                        <th rowspan="2">Type</th>
                        <th colspan="3">Horiz Error Detail (meters)</th>
                        <th colspan="3">Vert Error Detail (meters)</th>
                        <th rowspan="2"></th>
                    </tr>
                    <tr>
                        <th>Impl</th>
                        <th>Ext Wall &#8736;</th>
                        <th>&#8736;</th>
                        <th>Impl</th>
                        <th>Floor Var.</th>
                        <th>Uneven Floor</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let scoutPoint of scoutPoints;" [ngClass]="{'bg-warning':scoutPoint.disabled}">
                        <td style="color:white" [ngStyle]="{backgroundColor:scoutPoint.color}">{{scoutPoint.name}}</td>
                        <td style="color:blue" >{{scoutPoint.parentName}}</td>
                        <td class="text-nowrap">{{scoutPoint.horizontalDistance|number:'0.3-3'}}</td>
                        <td><span *ngIf="scoutPoint.horizontalError.cumulativeEstimate">{{scoutPoint.horizontalError.cumulativeEstimate|number:'0.1-3'}}</span></td>
                        <td>{{scoutPoint.bearing|number:'0.3-3'}}</td>
                        <td class="text-nowrap">{{scoutPoint.heightOffset}}</td>
                        <td><span *ngIf="scoutPoint.verticalError.segmentEstimate">{{scoutPoint.verticalError.segmentEstimate|number:'0.1-3'}}</span></td>
                        <td>{{scoutPoint.type}}</td>
                        <td>{{scoutPoint.horizontalError.implEstimate|number:'0.3-3'}}</td>
                        <td>
                            <ng-container *ngIf="scoutPoint.horizontalError.derivedFromExternalWall; else notDerivedFromExternalWall">
                            {{scoutPoint.horizontalError.externalWallAngleEstimate|number:'0.3-3'}}
                            </ng-container>
                            <ng-template #notDerivedFromExternalWall>
                                -
                            </ng-template>
                        </td>
                        <td>{{scoutPoint.horizontalError.measuredAngleEstimate|number:'0.3-3'}}</td>
                        <td>{{scoutPoint.verticalError.implEstimate|number:'0.3-3'}}</td>
                        <td>{{scoutPoint.verticalError.floorVarianceEstimate|number:'0.3-3'}}</td>
                        <td>
                            <ng-container *ngIf="scoutPoint.verticalError.unlevelFloor; else notUnlevelFloor">
                            {{scoutPoint.verticalError.unlevelFloorEstimate|number:'0.3-3'}}
                            </ng-container>
                            <ng-template #notUnlevelFloor>
                                -
                            </ng-template>
                        </td>
                        <td class="text-danger font-weight-bold">{{scoutPoint.disabled?'DISABLED':''}}</td>
                    </tr>
                    </tbody>
                </table>
                </ng-template>
            </td>
            <td style="vertical-align: top; padding:15px 0;">
                <span class="report-section-header">Path Segment B</span>
                <ng-container [ngTemplateOutlet]="pathSegmentTable"
                    [ngTemplateOutletContext]="{ scoutPoints: segmentBScoutPoints }">
                </ng-container>                            
            </td>
        </tr>
    </table>


    </ng-container>

    <br>
    <div class="report-section-header" style="page-break-before: always;">Extrapolated Test Point Calculator</div>
    <div id="visualization" class="p-2 pb-3">
        <span class="report-section-header">Visualization</span>
        <div class="d-flex flex-wrap" *ngIf="buildingPoints">
            <div *ngFor="let mapDef of mapDefs; index as index;" class="pr-2 pb-2">
            <app-scout-path-image 
                [zoomLevel]="mapDef.zoomLevel" 
                [mapStyle]="mapDef.style"
                [title]="mapDef.title"
                [overlay]="mapDef.overlay"
                [scoutPath]="scoutPath" 
                [selectedScoutPoint]="scoutPathStartPt"
                [buildingPoints]="buildingPoints"
                [imageCreateDelayMs]="leafletMapToImageWaitSecs*1000"
                (imageRenderRestarted)="pendingPlotterImageCnt=pendingPlotterImageCnt+1"
                (imageRenderComplete)="pendingPlotterImageCnt=pendingPlotterImageCnt-1">
            </app-scout-path-image>
            </div>            
        </div>
    </div>

    <ng-container>
    <br>
    <div id="path-point-metrics" class="p-2" style="page-break-before: always;">
        <br>
        <span class="report-section-header">Path Test Point Parameters</span>
    <div class="report-field-name">{{getPathName()}}</div>

    </div>
    <app-path-point-parameters-table #pathPointParamTable
        [scoutTask]="scoutTaskDoc" 
        [scoutPathIds]="[scoutPathId]"
        [detailFn]="detailFn">
    </app-path-point-parameters-table>

    <hr>

    <button *ngIf="!bShowPhotos" [disabled]="bEnablingPhotosPreview" class="btn btn-secondary mb-2" (click)="enablePhotosPreview()">
        <i *ngIf="bEnablingPhotosPreview" class="fa fa-spinner fa-spin mr-2"></i> Enable Photo Preview
    </button>
    <ng-container *ngIf="bShowPhotos">
        <button class="btn btn-secondary mb-2" (click)="bShowPhotos=false">
            Disable Photo Preview
        </button>
        <div class="pb-3" *ngFor="let reportScoutPoint of reportScoutPoints; index as scoutPointIndex;" style="page-break-before: always;">
        <div class="report-image-header p-1" [ngStyle]="{backgroundColor:reportScoutPoint.scoutPoint.color}">
            {{reportScoutPoint.scoutPoint.pointId || reportScoutPoint.scoutPoint.exPointId}} ({{reportScoutPoint.scoutPoint.name}} {{reportScoutPoint.scoutPoint.type}})
        </div>
        <div *ngIf="!reportScoutPoint.photoGroups?.length" style="padding:10px;font-style:italic;color:gray;">No pictures</div>
        <div *ngFor="let photoGroup of reportScoutPoint.photoGroups">
            <div class="h5 p-1" [ngStyle]="{backgroundColor:reportScoutPoint.scoutPoint.color+'80'}">{{photoGroup.title}}</div>
            <div class="d-flex flex-wrap pb-2" style="font-size:14px;">
                <div class="mr-2 my-1 p-sm-1" *ngFor="let reportPhoto of photoGroup.photos; index as photoIndex;" style="max-width:49%;border:1px solid rgb(232,232,232)">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="pr-1">
                            {{reportPhoto.photoDoc.title||(photoGroup.title+' #'+(photoIndex+1))}}
                        </div>
                        <div style="color:white;font-weight:bold;" [ngStyle]="{backgroundColor:reportScoutPoint.scoutPoint.color}">
                            {{reportScoutPoint.scoutPoint.name}} #{{photoIndex+1}}
                        </div>
                    </div>
                    <div class="text-center d-flex flex-column justify-content-around" style="min-height:3rem;">
                        <div *ngIf="reportPhoto.photoUrl; else noPhotoUrl">
                            <img [src]="reportPhoto.photoUrl" style="object-fit:contain;width:100%;max-width: 100%; max-height: 100%;">
                        </div>
                        <ng-template #noPhotoUrl>
                            <div *ngIf="reportPhoto.photoDoc?.uploadDate; else noImageUploaded">
                                <span *ngIf="!bProcessing" class="alert alert-warning align-self-center">
                                    <i class="fa fa-exclamation-triangle"></i> Photo assigned but could not be loaded.
                                </span>
                            </div>
                            <ng-template #noImageUploaded>
                                <span class="text-muted font-italic align-self-center">
                                    <i class="fa fa-camera"></i> No photo
                                </span>
                            </ng-template>
                        </ng-template>
                    </div>
                    <div class="text-muted small font-italic">
                        {{reportPhoto.photoDoc.fileName}} ({{reportPhoto.photoDoc.uploadDate}})
                    </div>
                    <div>
                        {{reportPhoto.photoDoc.notes}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    </ng-container>
    
    </ng-container>

    <canvas style="display: none;" #alterPhotoCanvas width="0" height="0" ></canvas>

</div>
